// Checkout URLs for each pack — easy to update from one place
export const CHECKOUT_URLS = {
  profesional:
    'https://profelisto.com.ar/checkouts/cn/hWNCObwXYVYVOaA2Pyx0qpRi/es-ar?_r=AQABKaNKVLxnIqNhfMM69fSnQrJYTCON2wAuRgnk3TkxL1o',
  elite:
    'https://profelisto.com.ar/checkouts/cn/hWNCObwy7umJHDPcmbK8OYvi/es-ar?_r=AQABM7_l1BuIuMc7P8o8Yr_HHsx7hGrlIVhoEY04Egy5NeI',
} as const

export type PackId = keyof typeof CHECKOUT_URLS

export function goToCheckout(packId: PackId): void {
  if (typeof window === 'undefined') return
  window.location.href = CHECKOUT_URLS[packId]
}
